import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../../../lib/pipes/safe-html.pipe';
import { DialogRef } from '../../dialog-ref';
import { DialogAbstract } from '../../dialog.abstract';
import { IAlertDialogData } from './alert-dialog.data';

export type AlertDialogRef = DialogRef<
  // eslint-disable-next-line no-use-before-define
  AlertDialogComponent,
  any | null,
  IAlertDialogData
>;

@Component({
  selector: 'trnty-alert-dialog',
  standalone: true,
  imports: [SafeHtmlPipe, TranslatePipe],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertDialogComponent extends DialogAbstract {
  declare dialogRef: AlertDialogRef;

  hasButtonData = computed(() => {
    return !!(
      this.dialogRef.data?.positiveButton ||
      this.dialogRef.data?.negativeButton ||
      this.dialogRef.data?.neutralButton
    );
  });

  onClickPositive(): void {
    this.close(this.dialogRef.data?.positiveButton?.value ?? true);
  }

  onClickNegative(): void {
    this.close(this.dialogRef.data?.negativeButton?.value ?? false);
  }

  onClickNeutral(): void {
    this.close(this.dialogRef.data?.neutralButton?.value ?? null);
  }
}
